import { useMediaQuery, Box, Drawer, Container, Stack, Typography, IconButton, Accordion, AccordionSummary, AccordionDetails, Button, Select, MenuItem } from '@mui/material';
import NavListing from './NavListing/NavListing';
import Logo from '../../shared/logo/Logo';
import { useSelector, useDispatch } from 'react-redux';
import { toggleMobileSidebar } from '../../../../store/customizer/CustomizerSlice';
import SidebarItems from '../../vertical/sidebar/SidebarItems';
import CloseIcon from '@mui/icons-material/Close';
import closeMenuImage from '../../../../assets/closeMenuImage.svg';
import routingGreenImage from '../../../../assets/routingGreenImage.svg';
import arrowRightImage from '../../../../assets/arrowRightImage.svg';
import profileGreenImage from '../../../../assets/profileGreenImage.svg';
import settingImage from '../../../../assets/settingImage.svg';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useNavigate } from 'react-router';
import { Link, NavLink } from 'react-router-dom';
import CustomButton from '../../../../components/shared/CustomButton';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import { DARCKBORDER, DARCKCOLOR } from '../../../../helpers/Config';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import termsImage from '../../../../assets/termsImage.svg';
import PublicOutlinedIcon from '@mui/icons-material/PublicOutlined';
import homeImg from '../../../../assets/homeImg.svg';
// import { onHoverLeave } from

const Navigation = () => {
  const lgUp = useMediaQuery((theme) => theme.breakpoints.up('lg'));
  const customizer = useSelector((state) => state.customizer);
  const user = useSelector((state) => state.userSlice.user);
  const language = useSelector((state) => state.userSlice.language);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleClose = () => {
    dispatch(toggleMobileSidebar());
  };
  // if (lgUp) {
  //   return (
  //     <Box sx={{ borderBottom: '1px solid rgba(0,0,0,0.05)' }} py={2}>
  //       {/* ------------------------------------------- */}
  //       {/* Sidebar for desktop */}
  //       {/* ------------------------------------------- */}
  //       <Container
  //         sx={{
  //           maxWidth: customizer.isLayout === 'boxed' ? 'lg' : '100%!important',
  //         }}
  //       >
  //         <NavListing />
  //       </Container>
  //     </Box>
  //   );
  // }

  const handleLanguageChange = (event) => {
  };

  return (
    <Drawer
      // anchor="left"
      anchor="right"
      open={customizer.isMobileSidebar}
      onClose={() => dispatch(toggleMobileSidebar())}
      variant="temporary"
      PaperProps={{
        sx: {
          width: customizer.SidebarWidth,
          minWidth: customizer.SidebarWidth,
          backgroundColor: 'rgba(245, 246, 247, 1)',
          color: customizer.activeSidebarBg === '#ffffff' ? '' : 'white',
          border: '0 !important',
          boxShadow: (theme) => theme.shadows[8],
        },
      }}
    >
      <Box
        mx={'auto'}
        sx={{
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          width: '100%',
          maxWidth: '1000px',
        }}
      >
        <Stack direction="row" alignItems="center" justifyContent={'space-between'} gap={'10px'} p={2} borderBottom={'1px solid rgba(33, 37, 41, 0.04)'}>
          <Stack direction="row" alignItems="center" gap={'10px'}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '48px',
                height: '48px',
                borderRadius: '50%',
                backgroundColor: '#038447',
                color: '#fff',
              }}
            >
              TR
            </Box>
            <Stack direction="row" alignItems="center">
              <Typography variant="body1" fontSize={'12px'} fontWeight={400} lineHeight={'16px'} color={DARCKCOLOR}>{user?.email || 'travelApp@gmail.com'}</Typography>
            </Stack>
          </Stack>
          <IconButton
            onClick={handleClose}
            sx={{
              width: '40px',
              height: '40px',
            }}
            >
            <Box 
              component={'img'}
              src={closeMenuImage}
              alt="close"
              />
          </IconButton>
        </Stack>
        {/* <Select
          value={language}
          onChange={handleLanguageChange}
          displayEmpty
          inputProps={{ 'aria-label': 'Language' }}
          sx={{
            borderRadius: '31px',
            backgroundColor: 'white',
            height: '36.6px',
            marginTop: '16px',
            marginRight: '16px',
            marginLeft: 'auto',
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: '#DFE5EF',
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: 'rgba(156, 163, 175, 0.8)',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: DARCKBORDER,
              borderWidth: '1px',
            },
            '& .MuiSelect-select': {
              padding: '10px 14px',
              fontSize: '12px',
              fontWeight: '400',
              lineHeight: '16px',
              color: 'rgba(0, 0, 0, 0.87)',
            },
            '& .MuiSelect-icon': {
              color: 'rgba(156, 163, 175, 1)',
            },
            '&.Mui-disabled .MuiOutlinedInput-notchedOutline': {
              borderColor: (theme) => theme.palette.grey[200],
            },
            '&.MuiInputBase-root': {
              padding: '2px 0 !important',
            },
          }}
        >
          {['DE', 'EN', 'FR'].map((lang, index) => (
            <MenuItem key={index} value={lang}>
              {lang}
            </MenuItem>
          ))}
        </Select> */}
        <Box
          display={'flex'}
          flexDirection={'column'}
          gap={1}
          p={'32px 16px'}
        >
          <Accordion
            onClick={() => dispatch(toggleMobileSidebar()) && navigate('/travel/landing')}
            expanded={false}
            sx={{
              '&.MuiAccordion-root': {
                boxShadow: 'none !important',
                borderRadius: '8px !important',
              },
            }}
          >
            <AccordionSummary
              expandIcon={
                <Box 
                  component={'img'}
                  src={arrowRightImage}
                  alt="img"
                  sx={{
                    width: '16px',
                    height: '16px',
                  }}
                />
              }
              aria-controls="panel1-content"
              id="panel1-header"
              sx={{
                height: '56px',
                minHeight: '56px !important',
                '&.Mui-expanded': {
                  height: '56px !important',
                  minHeight: '56px !important',
                },
                '& .MuiAccordionSummary-content': {
                  margin: '0px !important',
                  alignItems: 'center',
                },
              }}
            >
              <Stack direction="row" alignItems="center" gap={'4px'}>
                <Box 
                  component={'img'}
                  src={homeImg}
                  alt="img"
                  sx={{
                    width: '20px',
                    height: '20px',
                  }}
                />
                <Typography variant="body1" fontSize={'14px'} fontWeight={500} lineHeight={'20px'} color={DARCKCOLOR}>
                  Home page
                </Typography>
              </Stack>
            </AccordionSummary>
            <AccordionDetails>
              Lorem
            </AccordionDetails>
          </Accordion>
          <Accordion
            sx={{
              '&.MuiAccordion-root': {
                  boxShadow: 'none !important',
                  borderRadius: '8px !important',
                },
            }}
          >
            <AccordionSummary
              // expandIcon={<ExpandMoreIcon />}
              expandIcon={
                <Box 
                  component={'img'}
                  src={arrowRightImage}
                  alt="img"
                  sx={{
                    width: '16px',
                    height: '16px',
                    transform: 'rotate(90deg)',
                  }}
                />
              }
              aria-controls="panel1-content"
              id="panel1-header"
              sx={{
                height: '56px', 
                minHeight: '56px !important',
                '&.Mui-expanded': {
                  height: '56px !important', 
                  minHeight: '56px !important', 
                },
                '& .MuiAccordionSummary-content': {
                  margin: '0px !important', 
                  alignItems: 'center', 
                },
              }}
            >
              <Stack direction="row" alignItems="center" gap={'4px'}>
                <Box 
                  component={'img'}
                  src={routingGreenImage}
                  alt="img"
                  sx={{
                    width: '20px',
                    height: '20px',
                  }}
                />
                <Typography variant="body1" fontSize={'14px'} fontWeight={500} lineHeight={'20px'} color={DARCKCOLOR}>
                  Guides
                </Typography>
              </Stack>
            </AccordionSummary>
            <AccordionDetails
              sx={{
                background: 'rgba(245, 246, 247, 1)',
              }}
            >
              <Box
                display={'flex'}
                flexDirection={'column'}
                gap={2}
                mt={1}
              >
                <NavLink to={'/travel/guides'} onClick={() => dispatch(toggleMobileSidebar())} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '6px 0px'}}>
                  <Typography variant="body1" fontSize={'14px'} fontWeight={400} lineHeight={'20px'} color={DARCKCOLOR}>
                    Bookings
                  </Typography>
                  <Box
                    component={'img'}
                    src={arrowRightImage}
                    alt="img"
                    sx={{
                      width: '16px',
                      height: '16px',
                    }}
                  />
                </NavLink>
                <NavLink to={'/travel/guides'} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '6px 0px'}}>
                  <Typography variant="body1" fontSize={'14px'} fontWeight={400} lineHeight={'20px'} color={'rgba(30, 30, 31, 0.5)'}>
                    Favorites
                  </Typography>
                  <Typography variant="body1" fontSize={'12px'} fontWeight={300} lineHeight={'16px'} color={'rgba(30, 30, 31, 0.5)'}>
                    coming soon
                  </Typography>
                </NavLink>
                <NavLink to={'/travel/guides'} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '6px 0px'}}>
                  <Typography variant="body1" fontSize={'14px'} fontWeight={400} lineHeight={'20px'} color={'rgba(30, 30, 31, 0.5)'}>
                    My Guides
                  </Typography>
                  <Typography variant="body1" fontSize={'12px'} fontWeight={300} lineHeight={'16px'} color={'rgba(30, 30, 31, 0.5)'}>
                    coming soon
                  </Typography>
                </NavLink>
              </Box> 
            </AccordionDetails>
          </Accordion>
          <Accordion 
            onClick={() => dispatch(toggleMobileSidebar()) && navigate('/travel/profile')}
            expanded={false}
            sx={{
              '&.MuiAccordion-root': {
                  boxShadow: 'none !important',
                  borderRadius: '8px !important',
                },
            }}
          >
            <AccordionSummary
              // expandIcon={<ExpandMoreIcon />}
              expandIcon={
                <Box 
                  component={'img'}
                  src={arrowRightImage}
                  alt="img"
                  sx={{
                    width: '16px',
                    height: '16px',
                  }}
                />
              }
              aria-controls="panel1-content"
              id="panel1-header"
              sx={{
                height: '56px', 
                minHeight: '56px !important',
                '&.Mui-expanded': {
                  height: '56px !important', 
                  minHeight: '56px !important',
                },
                '& .MuiAccordionSummary-content': {
                  margin: '0px !important', 
                  alignItems: 'center', 
                },
              }}
            >
              <Stack direction="row" alignItems="center" gap={'4px'}>
                <Box 
                  component={'img'}
                  src={profileGreenImage}
                  alt="img"
                  sx={{
                    width: '20px',
                    height: '20px',
                  }}
                />
                <Typography variant="body1" fontSize={'14px'} fontWeight={500} lineHeight={'20px'} color={DARCKCOLOR}>
                  Profile 
                </Typography>
              </Stack>
            </AccordionSummary>
            <AccordionDetails>
              Lorem 
            </AccordionDetails>
          </Accordion>
          <Accordion
            onClick={() => dispatch(toggleMobileSidebar()) && navigate('/travel/settings')}
            expanded={false}
            sx={{
              '&.MuiAccordion-root': {
                boxShadow: 'none !important',
                borderRadius: '8px !important',
              },
            }}
          >
            <AccordionSummary
              expandIcon={
                // <ArrowDropDownIcon 
                //   sx={{
                //     fontSize: '20px', // Можна налаштувати розмір
                //     color: 'inherit', // Або змінити колір іконки
                //   }}
                // />
                <Box 
                  component={'img'}
                  src={arrowRightImage}
                  alt="img"
                  sx={{
                    width: '16px',
                    height: '16px',
                  }}
                />
              }
              aria-controls="panel1-content"
              id="panel1-header"
              sx={{
                height: '56px',
                minHeight: '56px !important',
                '&.Mui-expanded': {
                  height: '56px !important',
                  minHeight: '56px !important',
                },
                '& .MuiAccordionSummary-content': {
                  margin: '0px !important',
                  alignItems: 'center',
                },
              }}
            >
              <Stack direction="row" alignItems="center" gap={'4px'}>
                <Box 
                  component={'img'}
                  src={settingImage}
                  alt="img"
                  sx={{
                    width: '20px',
                    height: '20px',
                  }}
                />
                <Typography variant="body1" fontSize={'14px'} fontWeight={500} lineHeight={'20px'} color={DARCKCOLOR}>
                  Settings
                </Typography>
              </Stack>
            </AccordionSummary>
            <AccordionDetails>
              Lorem
            </AccordionDetails>
          </Accordion>
          <Accordion
            onClick={() => dispatch(toggleMobileSidebar()) && navigate('/travel/terms')}
            expanded={false}
            sx={{
              '&.MuiAccordion-root': {
                boxShadow: 'none !important',
                borderRadius: '8px !important',
              },
            }}
          >
            <AccordionSummary
              expandIcon={
                // <ArrowDropDownIcon 
                //   sx={{
                //     fontSize: '20px', // Можна налаштувати розмір
                //     color: 'inherit', // Або змінити колір іконки
                //   }}
                // />
                <Box 
                  component={'img'}
                  src={arrowRightImage}
                  alt="img"
                  sx={{
                    width: '16px',
                    height: '16px',
                  }}
                />
              }
              aria-controls="panel1-content"
              id="panel1-header"
              sx={{
                height: '56px',
                minHeight: '56px !important',
                '&.Mui-expanded': {
                  height: '56px !important',
                  minHeight: '56px !important',
                },
                '& .MuiAccordionSummary-content': {
                  margin: '0px !important',
                  alignItems: 'center',
                },
              }}
            >
              <Stack direction="row" alignItems="center" gap={'4px'}>
                <Box 
                  component={'img'}
                  src={termsImage}
                  alt="img"
                  sx={{
                    width: '20px',
                    height: '20px',
                  }}
                />
                <Typography variant="body1" fontSize={'14px'} fontWeight={500} lineHeight={'20px'} color={DARCKCOLOR}>
                  Terms and Conditions
                </Typography>
              </Stack>
            </AccordionSummary>
            <AccordionDetails>
              Lorem
            </AccordionDetails>
          </Accordion>
          {
            user?.isAdmin && (
              <Accordion
                onClick={() => dispatch(toggleMobileSidebar()) && navigate('/travel/admin')}
                expanded={false}
                sx={{
                  '&.MuiAccordion-root': {
                      boxShadow: 'none !important',
                      borderRadius: '8px !important',
                    },
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                  sx={{
                    height: '56px',
                    minHeight: '56px !important', 
                    '&.Mui-expanded': {
                      height: '56px !important', 
                      minHeight: '56px !important', 
                    },
                    '& .MuiAccordionSummary-content': {
                      margin: '0px !important',
                      alignItems: 'center', 
                    },
                  }}
                >
                  <Stack direction="row" alignItems="center" gap={'4px'}>
                    {/* <Box 
                      component={'img'}
                      src={settingImage}
                      alt="img"
                      sx={{
                        width: '20px',
                        height: '20px',
                      }}
                    /> */}
                    <AdminPanelSettingsIcon sx={{ color: 'rgba(3, 132, 68, 1)', width: '20px', height: '20px' }}/>
                    <Typography variant="body1" fontSize={'14px'} fontWeight={500} lineHeight={'20px'} color={DARCKCOLOR}>
                      Admin
                    </Typography>
                  </Stack>
                </AccordionSummary>
                <AccordionDetails>
                  Lorem 
                </AccordionDetails>
              </Accordion>
            )
          }
          <Box
            position={'fixed'}
            bottom={'32px'}
            left={'50%'}
            zIndex={5}
            display={'flex'}
            alignItems={'center'}
            justifyContent={'space-between'}
            gap={1}
            width={'100%'}
            maxWidth={'400px'}
            p={'0 16px'}
            sx={{ 
              transform: 'translate(-50%, 0)',
            }}
          >
            <CustomButton onClick={() => dispatch(toggleMobileSidebar())} to={`/travel`} height={'56px'}>Explore</CustomButton>
          </Box>
        </Box>

        {/* <CloseIcon
          onClick={handleClose}
          sx={{
            color: '#555',
            position: 'absolute',
            right: '5px',
            top: '5px',
            cursor: 'pointer',
            fontSize: '30px',
          }}
        /> */}
        {/* ------------------------------------------- */}
        {/* Sidebar For Mobile */}
        {/* ------------------------------------------- */}
        {/* <SidebarItems /> */}
        {/* ------------------------------------------- */}
        {/* Logo */}
        {/* ------------------------------------------- */}
      </Box>
    </Drawer>
  );
};

export default Navigation;
